// 版本号
export const VERSION = process.env.VUE_APP_VERSION;
// 网页基本路径
export const BASE_URL = process.env.BASE_URL;
// 接口请求的基本路径
export const INTERFACE_BASE_URL = process.env.VUE_APP_INTERFACE_BASE_URL;
// 店铺接口请求的基本路径
export const SHP_INTERFACE_BASE_URL = process.env.VUE_APP_SHP_INTERFACE_BASE_URL;
// 微信授权登录
export const WEIXIN_LOGIN_HOST = process.env.VUE_APP_WEIXIN_LOGIN_HOST;
// 接口secret
export const API_SECRET = process.env.VUE_APP_API_SECRET;

//vconsole
// import VConsole from "vconsole";
// export const vConsole = new VConsole();
